import { AspectRatio, Flex, SimpleGrid, Stack } from '@chakra-ui/react';
import React from 'react';
import Image from '../Image';
import SectionWithTitle from '../SectionWithTitle';
import StyledLink from '../StyledLink';
import Text from '../Text';

var StarProgramsSection = function StarProgramsSection(props) {
  var heading = props.heading,
      mainProgram = props.mainProgram,
      otherPrograms = props.otherPrograms;
  return /*#__PURE__*/React.createElement(SectionWithTitle, {
    heading: heading
  }, /*#__PURE__*/React.createElement(SimpleGrid, {
    columns: {
      base: 1,
      xl: otherPrograms !== null && otherPrograms !== void 0 && otherPrograms.length ? 2 : 1
    },
    justifyContent: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(AspectRatio, {
    ratio: {
      base: 1,
      xl: 1.23
    },
    width: "100%",
    maxWidth: 540,
    justifySelf: {
      base: 'center',
      xl: otherPrograms !== null && otherPrograms !== void 0 && otherPrograms.length ? 'flex-end' : 'center'
    }
  }, /*#__PURE__*/React.createElement(StyledLink, {
    to: mainProgram.uri,
    h: "100%",
    w: "100%"
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    bg: "blue.600",
    spacing: 0,
    position: "relative",
    h: "100%",
    w: "100%"
  }, /*#__PURE__*/React.createElement(Image, {
    image: mainProgram.image,
    style: {
      height: '100%'
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    align: "center",
    justify: "center",
    spacing: 0,
    minHeight: "80px",
    bg: "blue.600",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    textTransform: "uppercase",
    fontWeight: "900",
    color: "white"
  }, mainProgram.title), /*#__PURE__*/React.createElement(Text, {
    color: "white"
  }, mainProgram.description))))), /*#__PURE__*/React.createElement(Flex, {
    width: "100%",
    wrap: "wrap",
    justifySelf: {
      base: 'center',
      xl: 'flex-start'
    },
    maxW: {
      base: '100vw',
      md: 540
    }
  }, otherPrograms === null || otherPrograms === void 0 ? void 0 : otherPrograms.map(function (program, index) {
    return /*#__PURE__*/React.createElement(StyledLink, {
      key: program === null || program === void 0 ? void 0 : program.uri,
      to: program === null || program === void 0 ? void 0 : program.uri,
      w: "100%"
    }, /*#__PURE__*/React.createElement(Flex, {
      align: "center",
      bg: index % 2 ? 'primary.500' : 'primary.100',
      key: program === null || program === void 0 ? void 0 : program.uri,
      w: "100%"
    }, /*#__PURE__*/React.createElement(Image, {
      display: "flex",
      w: "50%",
      image: program === null || program === void 0 ? void 0 : program.image,
      order: index % 2 === 0 ? 0 : 1
    }), /*#__PURE__*/React.createElement(Flex, {
      w: "50%",
      direction: "column",
      align: "center",
      justify: "center",
      textAlign: "center",
      order: index % 2 === 0 ? 1 : 0,
      px: 2
    }, /*#__PURE__*/React.createElement(Text, {
      fontWeight: "bold",
      textVariant: "h4"
    }, program === null || program === void 0 ? void 0 : program.title), /*#__PURE__*/React.createElement(Text, {
      textVariant: "h4"
    }, program === null || program === void 0 ? void 0 : program.description))));
  }))));
};

export default StarProgramsSection;